import { all, call, put, takeEvery } from 'redux-saga/effects';
import { SET_ERROR, SET_ERROR_WAIVER, SET_LOADING, SET_LOADING_STATE, SET_LOADING_WAIVER } from './waiver.actions.js';
import WaiverServices from './waiver.services.js';
import actions from './waiver.types.js';

export function* HANDLE_STATE({ field, value }) {
    yield put({
        type: actions.SET_STATE,
        payload: {
            [field]: value,
        },
    });
}

export function* WAIVER({ payload }) {
    yield call(SET_LOADING_WAIVER, true);
    try {
        yield put(WaiverServices.doWaiver(payload));
    } catch (e) {
        yield call(SET_ERROR_WAIVER, e);
    }
}

export function* SUBMISSION({ payload, navigate, onSuccess }) {
    yield put({
        type: actions.SET_STATE,
        payload: {
            loadingSubmission: true,
        },
    });

    try {
        yield put(WaiverServices.doSubmission(payload, navigate, onSuccess));
    } catch (e) {
        yield put({
            type: actions.SET_STATE,
            payload: {
                loadingSubmission: false,
            },
        });
    } finally {
        yield put({
            type: actions.SET_STATE,
            payload: {
                loadingSubmission: false,
            },
        });
    }
}

export function* CHECK_PHONE_OR_EMAIL({ payload, navigate }) {
    yield call(SET_LOADING_STATE, 'loadingCheckPhone', true);
    try {
        yield put(WaiverServices.doCheckEmailOrPhone(payload, navigate));
    } catch (e) {
        yield call(SET_LOADING_STATE, 'loadingCheckPhone', false);
    }
}

export function* SET_MINOR({ payload }) {
    yield call(SET_LOADING, true);
    try {
        yield put(WaiverServices.doSetMinor(payload));
        yield put(WaiverServices.doCalculateOrder(payload));
    } catch (e) {
        yield call(SET_ERROR, e);
    } finally {
        yield call(SET_LOADING, false);
    }
}

export function* PAYMENT_PROCESS({ payload, navigate }) {
    yield call(SET_LOADING_WAIVER, true);
    try {
        yield put(WaiverServices.doPaymentProcess(payload, navigate));
    } catch (e) {
        yield call(SET_ERROR, e);
    }
}

export function* CHECK_EMAIL({ payload, navigate, onSuccess }) {
    yield call(SET_LOADING, true);
    try {
        yield put(WaiverServices.doCheckEmail(payload, navigate, onSuccess));
    } catch (e) {
        yield call(SET_ERROR, e);
    } finally {
        yield call(SET_LOADING, false);
    }
}

export function* LOGIN({ payload, navigate, onLogin }) {
    yield call(SET_LOADING_STATE, 'loadingSignIn', true);
    try {
        yield put(WaiverServices.doLogin(payload, navigate, onLogin));
    } catch (e) {
        yield call(SET_LOADING_STATE, 'loadingSignIn', false);
    } finally {
        yield call(SET_LOADING_STATE, 'loadingSignIn', false);
    }
}

export function* SIGN_IN({ payload, navigate, onLogin }) {
    yield call(SET_LOADING_STATE, 'loadingSignIn', true);
    try {
        yield put(WaiverServices.doSignIn(payload, navigate, onLogin));
    } catch (e) {
        yield call(SET_ERROR, e);
        yield call(SET_LOADING_STATE, 'loadingSignIn', false);
    } finally {
        yield call(SET_LOADING_STATE, 'loadingSignIn', false);
    }
}

export function* UPLOAD_IMAGE({ payload }) {
    yield call(SET_LOADING, true);
    try {
        yield put(WaiverServices.doUploadImage(payload));
    } catch (e) {
        yield call(SET_ERROR, e);
    }
}

export function* SEND_OTP({ payload, navigate, onSended }) {
    yield call(SET_LOADING_STATE, 'loadingSendOTP', true);
    try {
        yield put(WaiverServices.doSendOTP(payload, navigate, onSended));
    } catch (e) {
        yield call(SET_LOADING_STATE, 'loadingSendOTP', false);
    } finally {
        yield call(SET_LOADING_STATE, 'loadingSendOTP', false);
    }
}

export function* VERIFY_OTP({ payload, navigate, onVerified }) {
    yield call(SET_LOADING_STATE, 'loadingVerifyOTP', true);
    try {
        yield put(WaiverServices.doVerifyOTP(payload, navigate, onVerified));
    } catch (e) {
        yield call(SET_LOADING_STATE, 'loadingVerifyOTP', false);
    }
}

export function* SET_PASSWORD({ payload, navigate, onSuccess }) {
    yield call(SET_LOADING_STATE, 'loadingRegister', true);
    try {
        yield put(WaiverServices.doSetPassword(payload, navigate, onSuccess));
    } catch (e) {
        yield call(SET_LOADING_STATE, 'loadingRegister', false);
    } finally {
        yield call(SET_LOADING_STATE, 'loadingRegister', false);
    }
}

export function* FORGOT_PASSWORD({ payload, navigate, onSuccess }) {
    yield call(SET_LOADING_STATE, 'loadingSendOTP', true);

    try {
        yield put(WaiverServices.doForgotPassword(payload, navigate, onSuccess));
    } catch (e) {
        yield call(SET_ERROR, e);
    } finally {
        yield call(SET_LOADING_STATE, 'loadingSendOTP', false);
    }
}

export function* GET_ORDER_BY_ID({ payload }) {
    yield call(SET_LOADING, true);

    try {
        yield put(WaiverServices.doGetOrderById(payload));
    } catch (error) {
        yield call(SET_ERROR, error);
        yield call(SET_LOADING, false);
    } finally {
        yield call(SET_LOADING, false);
    }
}

export function* UPDATE_WAIVER({ payload }) {
    yield call(SET_LOADING_WAIVER, true);
    try {
        yield put(WaiverServices.doUpdateWaiver(payload));
    } catch (e) {
        yield call(SET_ERROR_WAIVER, e);
    }
}

export function* UPDATE_WAIVER_PHONE({ payload }) {
    yield call(SET_LOADING_WAIVER, true);
    try {
        yield put(WaiverServices.doUpdateWaiverPhone(payload));
    } catch (e) {
        yield call(SET_ERROR_WAIVER, e);
    }
}

export function* UPDATE_WAIVER_EMAIL({ payload }) {
    yield call(SET_LOADING_WAIVER, true);
    try {
        yield put(WaiverServices.doUpdateWaiverEmail(payload));
    } catch (e) {
        yield call(SET_ERROR_WAIVER, e);
    }
}

export function* CREATE_WAIVER_CHILD({ payload, navigate }) {
    yield call(SET_LOADING_WAIVER, true);
    try {
        yield put(WaiverServices.doCreateWaiverChild(payload, navigate));
    } catch (e) {
        yield call(SET_ERROR_WAIVER, e);
    }
}

export function* UPDATE_WAIVER_CHILD({ payload }) {
    yield call(SET_LOADING_WAIVER, true);
    try {
        yield put(WaiverServices.doUpdateWaiverChild(payload));
    } catch (e) {
        yield call(SET_ERROR_WAIVER, e);
    }
}

export function* DELETE_WAIVER_CHILD({ payload }) {
    yield call(SET_LOADING_WAIVER, true);
    try {
        yield put(WaiverServices.doDeleteWaiverChild(payload));
    } catch (e) {
        yield call(SET_ERROR_WAIVER, e);
    }
}

export default function* rootSaga() {
    yield all([
        takeEvery(actions.HANDLE_STATE, HANDLE_STATE),
        takeEvery(actions.WAIVER, WAIVER),
        takeEvery(actions.SUBMISSION, SUBMISSION),
        takeEvery(actions.CHECK_PHONE_OR_EMAIL, CHECK_PHONE_OR_EMAIL),

        takeEvery(actions.SET_MINOR, SET_MINOR),
        takeEvery(actions.PAYMENT_PROCESS, PAYMENT_PROCESS),

        takeEvery(actions.CHECK_EMAIL, CHECK_EMAIL),

        takeEvery(actions.SIGN_IN, SIGN_IN),
        takeEvery(actions.LOGIN, LOGIN),
        takeEvery(actions.UPLOAD_IMAGE, UPLOAD_IMAGE),
        takeEvery(actions.SEND_OTP, SEND_OTP),
        takeEvery(actions.VERIFY_OTP, VERIFY_OTP),
        takeEvery(actions.SET_PASSWORD, SET_PASSWORD),
        takeEvery(actions.FORGOT_PASSWORD, FORGOT_PASSWORD),
        takeEvery(actions.GET_ORDER_BY_ID, GET_ORDER_BY_ID),
        takeEvery(actions.WAIVER_UPDATE, UPDATE_WAIVER),
        takeEvery(actions.WAIVER_UPDATE_PHONE, UPDATE_WAIVER_PHONE),
        takeEvery(actions.WAIVER_UPDATE_EMAIL, UPDATE_WAIVER_EMAIL),
        takeEvery(actions.WAIVER_CREATE_CHILD, CREATE_WAIVER_CHILD),
        takeEvery(actions.WAIVER_UPDATE_CHILD, UPDATE_WAIVER_CHILD),
        takeEvery(actions.WAIVER_DELETE_CHILD, DELETE_WAIVER_CHILD),
    ]);
}
